import { Revert } from '../../utils/editorReactIcons';
export { Revert };
export default Revert;
